var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxboldtagVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8 11C8.73333 11 9.66667 10.6 10.2667 9.93333C10.2667 9.93333 12.6 7.33333 12.6 7.33333C13.5333 6.33333 13.5333 4.73333 12.6 3.66667C12.6 3.66667 10.2667 1.06667 10.2667 1.06667C9.66667 0.4 8.73333 0 7.8 0C7.8 0 3.33333 0 3.33333 0C1.46667 0 0 1.46667 0 3.33333C0 3.33333 0 7.66667 0 7.66667C0 9.53333 1.46667 11 3.33333 11C3.33333 11 7.8 11 7.8 11C7.8 11 7.8 11 7.8 11ZM5.19999 7.46664C5.13333 7.5333 4.99999 7.59997 4.86666 7.59997C4.73333 7.59997 4.59999 7.5333 4.53333 7.46664C4.53333 7.46664 2.93332 5.86663 2.93332 5.86663C2.73333 5.66664 2.73333 5.3333 2.93332 5.1333C3.13333 4.9333 3.46666 4.9333 3.66666 5.1333C3.66666 5.1333 4.93332 6.39997 4.93332 6.39997C4.93332 6.39997 7.79999 3.5333 7.79999 3.5333C7.99999 3.3333 8.33333 3.3333 8.53333 3.5333C8.73333 3.7333 8.73333 4.06663 8.53333 4.26663C8.53333 4.26663 5.19999 7.46664 5.19999 7.46664C5.19999 7.46664 5.19999 7.46664 5.19999 7.46664Z",
    transform: "translate(1.333 2.467)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxboldtagVerify);
export default __webpack_public_path__ + "static/media/vuesaxboldtag-verify.22d919be1d28aaf7bea63371be2f34b2.svg";
export { ForwardRef as ReactComponent };